import lodashGet from "lodash/get";

import {
  GET_PREFERENCES,
  SAVE_PREFERENCES,
  GET_PROFILE,
  GET_GROUP_MEMBERS,
} from "./actions.type";

import {
  SET_PREFERENCES,
  SET_PROFILE,
  SET_GROUP_MEMBERS,
} from "./mutations.type";

import {
  getPreferences,
  savePreferences,
  getProfile,
  getGroupMembers,
} from "@/services/user/user.service";

const STATE = {
  preferences: {},
  profile: {},
  groupMembers: null,
};

const GETTERS = {
  preferences: (state) => state.preferences,
  profile: (state) => state.profile,
  groupMembers: (state) => state.groupMembers,
};

const ACTIONS = {
  [GET_PREFERENCES](context) {
    try {
      const RESULT = getPreferences();
      context.commit(SET_PREFERENCES, RESULT);
    } catch (error) {
      console.error("Error in GET_PREFERENCES actions: " + error);
    }
  },
  async [SAVE_PREFERENCES](context, params) {
    try {
      let current = JSON.stringify(getPreferences());
      let updated = JSON.stringify(params);
      context.commit(SET_PREFERENCES, params);
      if (current !== updated) {
        const force = params && params.force ? true : false;
        delete params.force;
        await savePreferences(params, force);
      }
    } catch (error) {
      console.error("Error in SAVE_PREFERENCES actions: " + error);
    }
  },
  async [GET_PROFILE](context) {
    try {
      const RESULT = await getProfile();
      const { data } = JSON.parse(RESULT);

      if (data && data.user_profile) {
        delete data.user_profile.user_metadata;
        context.commit(SET_PROFILE, data.user_profile);
      }
    } catch (error) {
      console.error("Error in GET_PROFILE actions: " + error);
    }
  },
  async [GET_GROUP_MEMBERS](context) {
    //don't make additional calls to get group members
    if (lodashGet(context, "state.groupMembers")) {
      return;
    }
    try {
      const RESULT = await getGroupMembers();
      if (!RESULT) {
        return context.commit(SET_GROUP_MEMBERS, []);
      }
      const { data } = JSON.parse(RESULT);
      if (!data || !data.data) {
        return context.commit(SET_GROUP_MEMBERS, []);
      }
      const groupUsers = data.data;
      if (groupUsers && groupUsers instanceof Array) {
        return context.commit(SET_GROUP_MEMBERS, groupUsers);
      }
    } catch (error) {
      console.error("Error in GET_GROUP_MEMBERS actions: " + error);
    }
  },
};

const MUTATIONS = {
  [SET_PREFERENCES](state, data) {
    state.preferences = data;
  },
  [SET_PROFILE](state, data) {
    state.profile = data;
  },
  [SET_GROUP_MEMBERS](state, data) {
    state.groupMembers = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS,
};
